export default "__VITE_ASSET__BDY11XFS__"